import { useMemo } from "react";
import { string } from "prop-types";
import Linkify from "linkify-react";
import { replaceMentionLinks } from "@shared/mentionHelpers";

const mentionMap = new Map();

const LinkifyNotes = ({ markdownContent }) => {
  const noteContent = useMemo(
    () =>
      replaceMentionLinks(
        typeof markdownContent === "string" ? markdownContent : markdownContent?.message || "",
        mentionMap,
      ),
    [markdownContent],
  );

  return (
    <Linkify
      className="tw-text-[14px] tw-whitespace-pre-wrap tw-break-all tw-text-neutral-gray-75 tw-font-normal tw-leading-[20px] tw-tracking-normal"
      tagName="div"
      options={{
        defaultProtocol: "https",
        target: "_blank",
        render: {
          url: ({ attributes, content }) => {
            const segments = content.split("/");
            const potentialMentionId = segments[segments.length - 1].replace(/\W+$/, "");
            return (
              <a className="tw-text-theme-primary" onClick={(e) => e.stopPropagation()} {...attributes}>
                {mentionMap.has(potentialMentionId) ? `@${mentionMap.get(potentialMentionId)}` : content}
              </a>
            );
          },
        },
      }}
    >
      {noteContent}
    </Linkify>
  );
};

export default LinkifyNotes;

LinkifyNotes.propTypes = {
  markdownContent: string.isRequired,
};
